import createRequest from 'airship/modules/typesafe-request'
import getUrl from 'airship/modules/get-url'
import APP_KEY from 'airship/modules/app_key'
import reportError from 'airship/modules/report-error'

import {createFeaturesResolver, Features} from './types'

export async function resolveFeatures<T extends Features>(
  features: Readonly<T[]>
): Promise<Record<T, boolean>> {
  const request = createRequest({
    path: getUrl('resolve_features', APP_KEY),
  })

  try {
    const response = await request.get(createFeaturesResolver(features), {
      query: {features},
    })

    return response.body.features
  } catch (err) {
    reportError(err)
    throw err
  }
}
